var _style, _g, _g2, _path, _g3, _g4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EF9062;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#6B370E;}\n\t.st3{fill:none;stroke:#432918;stroke-width:1.5189;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.32,69.22l-2.69,0.79l-0.35,11.88l1.43,0.8c0,0,2.83,1.92,3.65-3.11c0.31-1.89,2.78-4.1,4.09-4.85 c3.2-1.81,8.95,0.4,9,5.09c0.03,2.55-0.49,5.01-1.66,7.17c-4.2,7.74-13.61,9.93-20.67,11.04c3.7-8.6,6.76-19.8,5.52-31.94h-0.96 c0.84-0.4,1.29-0.83,1.29-1.27c0-2.66-16.04-4.8-35.81-4.8c-19.78,0-35.8,2.14-35.8,4.8c0,0.44,0.45,0.87,1.28,1.27h-1.19 c0,0-3.13,28.1,16.1,49.75c0,0,18.95,7.99,39.79-0.92c0,0,1.94-2.36,4.4-6.46c1.25-0.47,3.35-1.42,6.9-3.28 c0,0,23.02-8,25.05-18.07C158.69,87.12,165.32,63.01,139.32,69.22z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "137.88,70.28 136.53,70.21 136.53,64.85 137.96,64.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66.28,70.33 67.79,70.1 67.79,64.73 66.36,64.73  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.79,88.8c0,0,3.34,9.88,7.09,16.51c3.6,6.36,3.88,6.13,3.88,6.13s5.76,2.84,14.29,3.28 s19.27-2.66,19.27-2.66s6.51-9.2,8.86-15.45c2.15-5.69,2.44-7.99,2.44-7.99s-8.2-2.57-27.25-2.84C83.31,85.52,73.79,88.8,73.79,88.8 z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M77.33,90.28c15.95,4.09,32.67,4.09,48.62,0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.74,135.9c-0.75-0.19-1.51-0.33-2.25-0.38c-0.42-0.03-0.87-0.02-1.27-0.33c-0.06-0.04-0.48-0.37-0.55-0.86 c-0.11-0.75,0.69-1.42,1.07-1.73c3.56-2.93,8.55-3.67,13.03-3.69c1.37-0.01,2.74,0.08,4.11,0.24c1.56,0.18,6.81,0.91,12.83,3.96 c4.39,2.23,7.09,4.63,7.85,5.32c1.37,1.26,2.85,2.83,4.17,4.78c1.61,2.37,4.43,6.82,0.92,8.92c-2.96,1.77-6.24,1.06-9.24-0.19 c-5.45-2.26-10.64-5.35-15.59-8.54c-1.72-1.11-3.57-2-5.34-3.01c-0.38-0.22-0.76-0.44-1.14-0.66c-0.54-0.31-2.01-1.17-3.93-2.12 c-0.69-0.34-1.43-0.68-2.4-1.02C89.28,136.35,88.52,136.1,87.74,135.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.9,154.51c0.75,0.19,1.51,0.33,2.25,0.37c0.42,0.03,0.87,0.02,1.27,0.33c0.06,0.04,0.48,0.37,0.55,0.85 c0.11,0.75-0.69,1.43-1.06,1.73c-3.55,2.94-8.54,3.69-13.02,3.73c-1.37,0.01-2.74-0.07-4.11-0.23c-1.56-0.18-6.82-0.89-12.84-3.92 c-4.39-2.21-7.11-4.61-7.86-5.3c-1.38-1.25-2.86-2.82-4.19-4.77c-1.61-2.37-4.45-6.81-0.95-8.92c3.44-2.07,6.88-0.89,10.23,0.59 c0.57,0.25,1.42,0.64,4.58,2.27c2.78,1.43,5.48,3.01,8.15,4.62c2.61,1.56,5.25,3.03,7.88,4.54c0.17,0.1,0.34,0.2,0.51,0.29 c0.54,0.31,2.01,1.17,3.94,2.11c0.69,0.33,1.43,0.68,2.4,1.01C120.36,154.07,121.13,154.32,121.9,154.51z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffee);
export default __webpack_public_path__ + "static/media/Coffee.3d0c3bb6a2ea2cb653e6dcb5000ae048.svg";
export { ForwardRef as ReactComponent };